
import { supabase } from '@/integrations/supabase/client';
import { setupOnlineStatusTracking } from './statusUpdater';

export const initializeUserSystems = async () => {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return;
    
    // Set up realtime presence for messages
    const channel = supabase.channel('user-presence', {
      config: {
        presence: {
          key: user.id,
        },
      },
    });
    
    // Track user's online state
    channel.on('presence', { event: 'sync' }, () => {
      // Presence state synced — used by online status system
    });
    
    await channel.subscribe(async (status) => {
      if (status === 'SUBSCRIBED') {
        await channel.track({
          user_id: user.id,
          online_at: new Date().toISOString(),
        });
      }
    });
    
    // Set up online status tracking with window events
    setupOnlineStatusTracking();
    
    return () => {
      supabase.removeChannel(channel);
    };
  } catch (error) {
    console.error('Error initializing user systems:', error);
  }
};
